<template>
  <div class="navbar__links">
    <ul class="navbar__links-list">
      <li
        v-for="link in filteredModuleLinks"
        :key="link.id"
        @click="setDefaultPath(link)"
      >
        <el-tooltip
          :open-delay="100"
          :content="$t(link.value)"
          placement="bottom"
          v-if="!link.routesLinks"
          :visible-arrow="false"
          popper-class="navbar-route-tooltip"
        >
          <router-link
            :class="['navbar__link', { active: $route.path === link.to }]"
            :to="link.to"
          >
            <r-icon
              :name="link.icon"
              :size="24"
              :color="$route.path === link.to ? 'white' : undefined"
            />
          </router-link>
        </el-tooltip>
        <routes-group v-else :routesGroup="link" />
      </li>
    </ul>
  </div>
</template>

<script>
import routesGroup from "./navbar-routes-group";
import { moduleLinks } from "../config/";

export default {
  components: {
    routesGroup
  },
  data() {
    return {
      moduleLinks
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    instance() {
      return this.$store.state.instance;
    },
    filteredModuleLinks() {
      const systemModuleLinks =
        this.moduleLinks[this.instance] || this.moduleLinks.default;

      return systemModuleLinks.filter(l => {
        if (!l.routesLinks) {
          return this.hasModule(l.name);
        } else {
          const hasAny = !!l.routesLinks.filter(k => this.hasModule(k.name))
            .length;
          if (hasAny) return true;
        }
      });
    }
  },
  methods: {
    hasModule(name) {
      return this.$store.getters.hasModule(name);
    },
    setDefaultPath(link) {
      if (link.routesLinks && link.routesLinks.length) return;
      this.$store.commit("SET_DEFAULT_PATH", link.to);
      this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
    }
  }
};
</script>

<style lang="scss">
.navbar__links {
  height: 100%;
  display: flex;
  align-items: flex-start;
  margin-left: 8px;

  &-list {
    height: 100%;
    display: flex;
    align-items: center;
    &__item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 32px;
    }

    li {
      display: flex;
      height: 32px;
      box-sizing: border-box;
      min-width: 32px;
      margin-right: 4px;
      position: relative;
      align-items: center;
      &:last-child {
        margin-right: 0;
      }
    }
    .navbar__link {
      position: relative;
      display: block;
      height: 100%;
      width: 100%;
      border-radius: 4px;
      box-sizing: border-box;
      outline: none !important;
      transition: all 0.15s ease;
      border: 2px solid;
      border-color: transparent;
      &:hover {
        background-color: var(--accent_selected) !important;
      }
      &.active {
        background-color: var(--accent_selected) !important;
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "r-library": "Библиотека компонентов",
    "traffic-counts": "Замеры интенсивности",
    "situation-center": "Ситуационный центр"
  },
  "en": {
    "r-library": "RITM - library",
    "traffic-counts": "Traffic Counts",
    "situation-center": "Situation Center"
  }
}
</i18n>
